/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Wigbertschule1Inputs */

const en__field_enum_wigbertschule1 = /** @type {(inputs: _Field_Enum_Wigbertschule1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hünfeld`)
};

const de__field_enum_wigbertschule1 = /** @type {(inputs: _Field_Enum_Wigbertschule1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wigbertschule`)
};

/**
* | output |
* | --- |
* | "Hünfeld" |
*
* @param {_Field_Enum_Wigbertschule1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_wigbertschule1 = /** @type {((inputs?: _Field_Enum_Wigbertschule1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Wigbertschule1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_wigbertschule1(inputs)
	return de__field_enum_wigbertschule1(inputs)
});
export { _field_enum_wigbertschule1 as "_field_enum_Wigbertschule" }